import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { login } from "../../../images";

export class Dashboard extends Component {
  render() {
    let imageUrl = login.background;

    return (
      <div className="md:tw-flex md:tw--mx-2">
        <div
          className="tw-w-full tw-bg-cover tw-bg-center tw-flex tw-items-center tw-justify-center"
          style={{ backgroundImage: `url(${imageUrl})`, height: "70vh" }}
        >
          <div className="tw-text-center">
            <Link to="/collection-orders/new" className="tw-no-underline">
              <div className="tw-py-6 tw-bg-tosca-orange tw-rounded tw-shadow-md tw-px-6 tw-text-white tw-mb-6 xs:tw-w-48 xs:tw-h-9 xs:tw-px-0 xs:tw-text-xs xs:tw-py-2">
                Create New Collection Order
              </div>
            </Link>
            <Link to="/collection-orders" className="tw-no-underline">
              <div className="tw-py-6 tw-bg-tosca-orange tw-rounded tw-shadow-md tw-px-6 tw-text-white xs:tw-w-48 xs:tw-h-9 xs:tw-text-xs xs:tw-py-2">
                Review History
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = ({ session }) => ({
  accessToken: session.user.accessToken,
});

export default connect(mapState)(Dashboard);
